var map = {
	"./logo-abc.png": "f6ad",
	"./logo-aldrive.png": "924a",
	"./logo-alquimia.png": "45e4",
	"./logo-balamboo.png": "1c93",
	"./logo-beatup.png": "653a",
	"./logo-casa.png": "ac1f6",
	"./logo-drawThings.png": "07a8",
	"./logo-drawthingsonline.png": "eac7",
	"./logo-dreamocean.webp": "b412",
	"./logo-idea.png": "4dc5",
	"./logo-kiwen.png": "4674",
	"./logo-l-vk.png": "deae",
	"./logo-makine.png": "f2b5",
	"./logo-movies.png": "d76f",
	"./logo-mrclick.png": "c863",
	"./logo-og.png": "a0ce",
	"./logo-pocketorbit.png": "939e",
	"./logo-rubik.png": "5c9d",
	"./logo-spokes.png": "60c2",
	"./logo-temac.png": "e0f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1195";